import initMetrika from '@ps-int/ufo-rocks/lib/metrika';
import noop from 'lodash/noop';

import isOnPremise from '../onpremise/is-onpremise';
import type { InitMetrika } from './types';

interface Counter {
    count(...args: MetrikaParam[]): void;
    reachGoal(goalId: string, params?: Record<string, string>): void;
    countObj(object: Record<string, unknown>): void;
}
let counter: Counter | null = null;
let initMetrikaOptions: InitMetrika;

export type MetrikaParam = string | number | Record<string, string>;

/**
 * Инициализация счётчика метрики.
 *
 * @param {Object} options - Объект с дополнительными опциями для инициализации метрики.
 * @param {number} options.metrikaCounterId id счетчика метрики
 * @param {string} [options.experiments]
 */
export const init = (options: InitMetrika) => {
    if (isOnPremise) {
        return;
    }

    const { metrikaCounterId, experiments } = options;
    initMetrikaOptions = options;

    counter = initMetrika({
        id: metrikaCounterId,
        clickmap: true,
        trackLinks: true,
        accurateTrackBounce: true,
        ut: 'noindex',
        experiments,
    });
};

const cloudCountMetrika = (...args: MetrikaParam[]) => {
    if (!counter || !initMetrikaOptions) {
        return;
    }

    const params = [initMetrikaOptions.prefix, ...args];
    counter.count(...params);
};

const cloudCountMetrikaGlobalBar = (...args: MetrikaParam[]) => {
    if (!counter || !initMetrikaOptions) {
        return;
    }

    counter.count(...args);
};

const cloudCountMetrikaObj = (object: Record<string, unknown>) => {
    if (!counter || !initMetrikaOptions) {
        return;
    }

    counter.countObj({ [initMetrikaOptions.prefix]: object });
};

const cloudReachGoal = (goalId: string) => {
    if (!counter) {
        return;
    }

    counter.reachGoal?.(goalId, {});
};

/**
 * Отправка метрики счётчик.
 *
 * @param {(string | number)[]} args
 */
export const countMetrika = isOnPremise ? noop : cloudCountMetrika;
export const countMetrikaGlobalBar = isOnPremise ? noop : cloudCountMetrikaGlobalBar;
export const countMetrikaObj = isOnPremise ? noop : cloudCountMetrikaObj;

export const reachGoal = isOnPremise ? noop : cloudReachGoal;
